import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    // We use a React Fragment <> because the elements will be positioned independently
    <>
      <div className="logo-container">
        <Link to="/" className="logo-link">flavy.us</Link>
      </div>
      
      <nav className="nav-container">
        <a href="/#about">Despre</a>
        <a href="/#projects">Proiecte</a>
        <a href="/#contact">Contact</a>
      </nav>
    </>
  );
}

export default Header;